<template>
  <div style="padding-top:120px">
    <!-- <div class="bannerWrap">
      <div class="infos">
        <div>{{ detailData.caseTitle }}</div>
        
        <img  src="https://www.xaryxx.com/images/images2/s41.png" alt="">
      </div>
      <img class="banner" src="../../assets/banner/anlidetail.jpg" alt="">
    </div>

    <div class="content" style="flex-direction: column">
      <div class="title">
        {{ detailData.caseTitle }}
      </div>
      <div class="date">发布时间：{{ detailData.publishDate }}</div>
      <div class="left-text">
        <p>
          {{ detailData.introduction }}
        </p>
       
      </div>
    </div> -->
    <div class="htmls" v-html="detailData.caseDetails"></div>
  </div>
</template>

<script>
import NewsList from "../common/news-list";
import BannerTitle from "../common/banner-title";
import PageItem from "../common/page-item"

import { detail1 } from "@/api/api";



export default {
  name: "news",
  components: {
    NewsList,
    BannerTitle,
    PageItem
  },
  created() {
    let self = this;
    let params = self.$route.query;
    if (params) {
      self.current = params.current || 0
      detail1(params.id).then((result) => {

        console.log(result.data,88888888888)
        self.detailData = result.data
      }).catch((err) => {
        console.log(err);
      })

    }

  },
  data() {
    return {
      detailData: {},
      listData: [],
      navList: [
        { label: "公司动态", value: 0 },
        { label: "行业资讯", value: 1 }
      ],
      current: 0
    };
  },
  methods: {
    // showContent: function(current) {
    //   this.current = current;
    // }
    getNewList(item) {
      this.$router.push({ path: 'newsList', query: { id: item.id, current: this.current } })
    },
  }
};
</script>
<style lang="less" scoped>
.htmls{
  min-height: 600px;
}
/deep/ .left-text img{
  display: block;
  width: 100%;
}
.bannerWrap{
  position: relative;
  .banner{
  width: 100%;
  display: block;
}
.infos{
  display: flex;
  align-items: center;
  font-family: Adobe Heiti Std;
font-weight: normal;
font-size: 22px;
color: #FC700F;
line-height: 24px;
  position: absolute;
  bottom: 18%;
  left:17%;
  // width: 50%;
 >div{
  flex: 1;
 }
  img{
    display: block;
    margin-left: 15px;
    width: 32px !important;
    height: 27px !important;
  }
}
}

 /deep/ img{
    display: block;
    width: 100% !important;
  }

.content {
  width: 74rem;
  padding: 30px 3rem;
  margin: 30px auto;

  .title {
    text-align: center;
    font-size: 26px;
font-family: PingFang SC-Semibold, PingFang SC;
font-weight: 600;
color: #333333;
    line-height: 34px;
  }
 
  .date {
    padding: 30px 0;
    font-size: 16px;
font-family: PingFang SC-Regular, PingFang SC;
font-weight: 400;
color: #666666;
line-height: 23px;
    text-align: center;
  }

  p {
    font-weight: bold;
    font-size: 17px;
  }

  .htmls {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 32px;
  }



}
</style>



// WEBPACK FOOTER //
// src/components/detail/index1.vue